export const selectIsLoading = state => state.settings.isLoading;

export const selectIsStaffUpdating = state => state.settings.isStaffUpdating;

export const selectError = state => state.settings.error;

export const selectSchedule = state => state.settings.schedule;

export const selectPosts = state => state.settings.posts;

export const selectPartsPrices = state => state.settings.partsPrices;

export const selectOtherServicesPrices = state => state.settings.otherServicesPrices;

export const selectIsUploadingOtherServicesPrices = state =>
  state.settings.isUploadingOtherServicesPrices;

export const selectIsUploadingPartsPrices = state =>
  state.settings.isUploadingPartsPrices;

export const selectServicesPrices = state => state.settings.pricesForDiagnostic;

export const selectEditedServices = state => state.settings.editedServices;

export const selectEmployees = state => state.settings.employees;

export const selectMechanics = state => state.settings.mechanics;

export const selectEmployeeFormData = state => state.settings.employeeFormData;

export const selectPermissionsList = state => state.settings.permissionsList;

export const selectPermissionsByRole = state => state.settings.permissionsByRole;

export const selectAllSuppliers = state => state.settings.suppliers;

export const selectSupplierWarehouses = state => state.settings.supplierWarehouses;

export const selectCurrentSupplier = state => state.settings.supplier;

export const selectIsModalOpen = state => state.settings.isModalOpen;

export const selectAllCashregisters = state => state.settings.cashRegisters;

export const selectIsCashRegistersLoading = state => state.settings.isCashRegistersLoading;

export const selectIsTestingSupplierConnection = state =>
  state.settings.isTestingSupplierConnection;

export const selectTutorialPage = state => state.settings.tutorialSection;

export const selectSettingsPage = state => state.settings.settingsPage;

export const selectTutorialNavigation = state =>
  state.settings.tutorialNavigation;

export const selectFinishedPages = state => state.settings.finishedPages;

export const selectLegalPersonType = state => state.settings.legalPersonType;

export const selectIsServiceAccordionExpanded = state =>
  state.settings.isServiceAccordionExpanded;

export const selectOpenTutorial = state => state.settings.isTutorialOpen;

// ! MARKUP
export const selectMarkups = state => state.settings.markups;

// ! INTEGRATION
export const selectIntegration = state => state.settings.integration;

// ! LICENSE
export const selectLicense = state => state.settings.license;

export const selectLicenseRequest = state => state.settings.licenseRequest;

